import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-fixed',
  templateUrl: './d-con-fixed.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DConFixedComponent),
      multi: true
    }
  ]
})
export class DConFixedComponent extends DynamicComponentBase {
  static KEY = 'd-con-fixed';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (!config.effective) {
      config.effective = [];
    }
  }
}
